import { memo } from "react";
import styles from "./styles.module.sass";
import clsx from "clsx";
import { formatLectureTime } from "@shared/functions/formatLectureTime";
import { LectureResponse } from "@services/api/lectures/typedef";
import { pluralForm } from "@shared/functions/pluralForm";
import { useStore } from "effector-react";
import { $course } from "@features/Course/model/public";
import { $authedUser } from "@features/Auth/model/public";

type SectionItemProps = {
	item: LectureResponse;
	handleFreeClick: (item: LectureResponse) => void;
};

const SectionItem = memo(({ item, handleFreeClick }: SectionItemProps) => {
	const { meta, type } = item;
	const isQuestion = meta !== null && "questions" in meta;
	const isQuizz = meta !== null && "terms" in meta;
	const isTextLecture = meta !== null && "timeToRead" in meta;
	const lecturesType: Array<LectureResponse["type"]> = ["audio", "video"];

	const course = useStore($course);
	const authedUser = useStore($authedUser);

	const textOfFreeMaterialByLectureType = {
		text: "Читать бесплатно",
		audio: "Слушать бесплатно",
		video: "Смотреть бесплатно",
		quiz: "Пройти бесплатно",
		test: "Пройти бесплатно",
	};

	const materialType = {
		text: "Лекция",
		audio: "Аудиолекция",
		video: "Видеолекция",
		quiz: "Квиз",
		test: "Тест",
	};

	const freeMaterialText = textOfFreeMaterialByLectureType[type];
	const materialTypeTitle = materialType[type];

	const isAuthedUserAreCreatorOfCurrentCourse = authedUser?.id === course?.authorId;
	const isItemFree = item.isFree;
	const isModerator = authedUser?.role === "moderator";

	return (
		<>
			<div className={styles.itemTitleWrapper}>
				<div
					title={materialTypeTitle}
					className={clsx(styles.itemIcon, {
						[styles.lecture]: item.duration !== undefined && lecturesType.includes(item.type),
						[styles.test]: isQuestion && meta?.questions.length !== 0,
						[styles.quiz]: isQuizz && meta?.terms.length !== 0,
					})}
				/>
				<button
					className={clsx(styles.content, {
						[styles.free]: isItemFree,
					})}
					onClick={
						isItemFree || isAuthedUserAreCreatorOfCurrentCourse || isModerator
							? () => {
									return handleFreeClick(item);
							  }
							: undefined
					}
				>
					<span className={styles.title}>{item.title}</span>
				</button>
			</div>
			<div className={styles.freeAndDetailsContainer}>
				{isItemFree && (
					<button
						className={styles.watchFree}
						onClick={() => {
							return handleFreeClick(item);
						}}
					>
						{freeMaterialText}
					</button>
				)}
				<p className={styles.details}>
					{lecturesType.includes(type) && formatLectureTime(item.duration)}
					{isTextLecture && `${meta.timeToRead} минут`}
					{isQuestion &&
						`${meta.questions.length} ${pluralForm(meta.questions.length, "вопрос", "вопроса", "вопросов")}`}
					{isQuizz &&
						`${meta.terms.length} ${pluralForm(meta.terms.length, "карточка", "карточки", "карточек")}`}
				</p>
			</div>
		</>
	);
});

export default SectionItem;

SectionItem.displayName = "SectionItem";
